export function formatNumber(num) {
  let formatted = ''
  num = Math.abs(num)

  if (num >= 1_000_000) {
    formatted = (num / 1_000_000).toFixed(1) + 'M'
  } else if (num >= 1_000) {
    let value = num / 1_000
    formatted = value >= 100 ? value.toFixed(0) + 'K' : value.toFixed(1) + 'K'
  } else {
    formatted = num >= 100 ? num.toFixed(1).toString() : num.toFixed(2).toString()
    // formatted = num.toFixed(2).toString()
  }

  formatted = formatted.replace(/(\.0+|(\.\d*?[1-9])0+)$/, '$2')

  return formatted
}
